"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elements = exports.Type = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _Type = require("./Type.js");
var _excluded = ["color", "semanticColor", "paddingBottom", "variant", "weight"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TypeComponent = /*#__PURE__*/_react["default"].forwardRef(function TypeComponent(_ref, ref) {
  var color = _ref.color,
    semanticColor = _ref.semanticColor,
    paddingBottom = _ref.paddingBottom,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'viola' : _ref$variant,
    weight = _ref.weight,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Type.TypeElement, Object.assign({
    $variant: variant,
    $semanticColor: semanticColor,
    $paddingBottom: paddingBottom,
    $weight: weight,
    ref: ref
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.Type
  }));
});

// export components
var elements = exports.elements = {
  /**
   * @deprecated
   * Use `<Type as="h1" />` instead.
   */
  h1: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TypeComponent, Object.assign({
      as: "h1",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="h2" />` instead.
   */
  h2: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TypeComponent, Object.assign({
      as: "h2",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="h3" />` instead.
   */
  h3: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TypeComponent, Object.assign({
      as: "h3",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="h4" />` instead.
   */
  h4: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TypeComponent, Object.assign({
      as: "h4",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="h5" />` instead.
   */
  h5: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TypeComponent, Object.assign({
      as: "h5",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="h6" />` instead.
   */
  h6: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TypeComponent, Object.assign({
      as: "h6",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="p" />` instead.
   */
  p: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TypeComponent, Object.assign({
      as: "p",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="small" />` instead.
   */
  small: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TypeComponent, Object.assign({
      as: "small",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="li" />` instead.
   */
  li: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TypeComponent, Object.assign({
      as: "li",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type />` instead (span is the default element).
   */
  span: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TypeComponent, Object.assign({
      as: "span",
      ref: ref
    }, props));
  })
};
var typeHelpers = _objectSpread(_objectSpread({}, elements), _Type.weights);

/**
 * @deprecated
 * This component is deprecated in favor of
 * the {@link https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-text--docs Text} component.
 *
 * Please refer to the {@link https://encore.spotify.net/whats-new/announcing-layout-themes?format=figma-figma#whats-happening Type-to-text migration chart}
 * and {@link https://encore.spotify.net/components/text?format=web-js#setup-2 setup steps for the Text component}.
 *
 * We have also provided a {@link https://backstage.spotify.net/codemods/encore-text-migrator/encore-web Codemod} for the Type-to-Text migration.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-type--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Type)
 */
var Type = exports.Type = Object.assign(TypeComponent, typeHelpers);